import type {SearchStoreState} from 'app/core/searchAutocompleteCommon/interface';
import type {NamedSetState} from 'app/gemStore/devtools';

import type {SiteSearchSlice} from './types';

const siteSearchInitialState: SearchStoreState = {
    query: '',
    expanded: false,
};

export const createSiteSearchSlice = (set: NamedSetState<SiteSearchSlice>, get: () => SiteSearchSlice) => ({
    siteSearch: siteSearchInitialState,
    setSiteSearchQuery: (query: string) => {
        set({siteSearch: {...get().siteSearch, query}}, false, 'siteSearch/setSiteSearchQuery');
    },
    setSiteSearchExpanded: (expanded: boolean) => {
        set({siteSearch: {...get().siteSearch, expanded}}, false, 'siteSearch/setSiteSearchExpanded');
    },
});
